// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: names and icons for the desktop sidebar's page buttons, shared by
// Settings ("Open Konvo on" and Appearance > Sidebar > Pages) and the avatar
// pop-up's More tiles. Names follow the sidebar tooltips; brand pages draw
// the same logos as their sidebar buttons.

import {MobileRailTabIcon} from '@app/features/app/components/layout/mobile_rail/MobileRailTabLabels';
import type {SidebarPageId} from '@app/features/app/components/layout/sidebar_nav/SidebarPages';
import {ClickUpLogo} from '@app/features/ui/components/icons/ClickUpLogo';
import {OutlookCalendarLogo} from '@app/features/ui/components/icons/OutlookCalendarLogo';
import {OutlookLogo} from '@app/features/ui/components/icons/OutlookLogo';
import {WhatsAppLogo} from '@app/features/ui/components/icons/WhatsAppLogo';
import {ChatCircleIcon, HouseIcon} from '@app/features/ui/icons/Icons';
import type {MessageDescriptor} from '@lingui/core';
import {msg} from '@lingui/core/macro';
import type React from 'react';

export const SIDEBAR_PAGE_LABELS: Record<SidebarPageId, MessageDescriptor> = {
	home: msg({message: 'Home', comment: 'Desktop sidebar page in "Open Konvo on": the Home page.'}),
	chats: msg({message: 'Chats', comment: 'Desktop sidebar page in "Open Konvo on": the chats list.'}),
	calendar: msg({message: 'Calendar', comment: 'Desktop sidebar page in "Open Konvo on": the calendar.'}),
	mail: msg({message: 'Emails', comment: 'Desktop sidebar page in "Open Konvo on": the Outlook mailbox.'}),
	clickup: msg({message: 'Tasks', comment: 'Desktop sidebar page in "Open Konvo on": the ClickUp tasks page.'}),
	whatsapp: msg({message: 'WhatsApp', comment: 'Desktop sidebar page in "Open Konvo on": the WhatsApp page.'}),
	agents: msg({
		message: 'Agents',
		comment: 'Desktop sidebar page in "Open Konvo on": the coding agents page (T3 Code threads).',
	}),
	scheduled: msg({
		message: 'Scheduled',
		comment:
			'Desktop sidebar page in "Open Konvo on": the Scheduled page listing everything coming up (reminders, scheduled messages, automations, digests, promises).',
	}),
};

export function SidebarPageIcon({page, size = 20}: {page: SidebarPageId; size?: number}): React.ReactElement {
	switch (page) {
		case 'home':
			return <HouseIcon size={size} />;
		case 'chats':
			return <ChatCircleIcon size={size} />;
		case 'calendar':
			return <OutlookCalendarLogo size={size} />;
		case 'mail':
			return <OutlookLogo size={size} />;
		case 'clickup':
			return <ClickUpLogo size={size} />;
		case 'whatsapp':
			return <WhatsAppLogo size={size} />;
		case 'agents':
			return <MobileRailTabIcon tab="agents" size={size} />;
		case 'scheduled':
			return <MobileRailTabIcon tab="scheduled" size={size} />;
	}
}
